export const NavData = [
  {
    name: "home",
    link: "/",
    id: 1000,
  },
  {
    name: "Features",
    link: "features",
    id: 1001,
  },
  {
    name: "Process",
    link: "process",
    id: 1005,
  },
  {
    name: "Resume",
    link: "resume",
    id: 1002,
  },
  {
    name: "Blog",
    link: "blog",
    id: 1003,
  },
  {
    name: "Contacts",
    link: "contacts",
    id: 1004,
  },
];
